








































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import pdf from 'pdfvuer';
import { Action, Getter } from 'vuex-class';
import { Element as CanvasElement, ElementActionsKeys, ElementActionsPayload } from '@/store/types/element';
import { getFileUrl } from '@/utils';
import PdfToolbar from '../Toolbars/PdfToolbar.vue';
import { RootGettersReturns } from '@/store/types';

@Component({
  components: {
    pdf,
    PdfToolbar,
  },
})
export default class PdfElement extends Vue {
  @Prop(String) filename!: string;
  @Prop(Number) currentPage!: number;
  @Prop({ type: Object }) element!: CanvasElement;
  @Prop(Boolean) selected!: boolean;
  @Prop(Boolean) doubleSelected!: boolean;
  @Prop(Boolean) office?: boolean;
  @Action(ElementActionsKeys.UPDATE_ELEMENT) updateElement!: (payload: ElementActionsPayload['UPDATE_ELEMENT']) => void;
  @Action(ElementActionsKeys.SET_DOUBLE_SELECTED) setDouble!: (
    payload: ElementActionsPayload['SET_DOUBLE_SELECTED']
  ) => void;
  @Getter currentUser!: RootGettersReturns['currentUser'];
  @Getter isGuest!: RootGettersReturns['isGuest'];
  @Getter sessionUsers!: RootGettersReturns['sessionUsers'];

  url = '';
  pdfUrl: { numPages: number } = { url: '' } as never;
  pages = 0;

  @Watch('element', { immediate: true })
  watchElement(newVal: CanvasElement) {
    if (!newVal || !this.$refs[`page`]) return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (this.$refs[`page`] as any).drawScaled('page-width');
  }

  async mounted() {
    if (!this.office) {
      this.$parent.$parent.$emit('updateMoveableComponent', {
        keepRatio: true,
      });
    }
    await this.setNewUrl();
    this.pdfUrl = pdf.createLoadingTask(this.url);
    let pdfTask;
    try {
      pdfTask = await this.pdfUrl;
    } catch {
      await this.setNewUrl();
      pdfTask = await this.pdfUrl;
    }
    this.pages = pdfTask.numPages;
    await this.updateElement({
      ...this.element,
      data: {
        ...this.element.data,
        pages: this.pages,
      },
    });
  }

  async setNewUrl() {
    this.url = await getFileUrl(this.filename);
  }

  async finishLoading(loading: boolean) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (loading || (this.element.data as any).loaded) return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const page = (this.$refs.container as any).querySelector('#page') as HTMLElement;
    await this.updateElement({
      ...this.element,
      width: page.clientWidth,
      height: page.clientHeight,
      data: {
        ...this.element.data,
        loaded: true,
      },
    });
  }

  get tooltipText() {
    const id = (this.element.data as { usedBy: number | boolean }).usedBy;
    const user = this.sessionUsers.find(user => user.id === id);
    if (user) return `${user.fullName} is typing`;
    return 'Element is shared';
  }

  tooltipColor(id: number) {
    const user = this.sessionUsers.find(user => user.id === id);
    if (user) return user.colorCode;
    return 'currentColor';
  }

  get isShared() {
    return (this.element.data as { shared: boolean }).shared;
  }

  get isUsed() {
    return !!(this.element.data as { usedBy: number | boolean }).usedBy;
  }

  get isLocked() {
    return (
      (this.element.data as { usedBy: number | boolean }).usedBy &&
      (this.element.data as { usedBy: number }).usedBy !== this.currentUser?.id
    );
  }
  snackbar = false;
  snackbarText = '';
  snackbarTimeout = 2000;

  @Watch('element', { deep: true })
  elementUpdate(newVal: CanvasElement, oldVal: CanvasElement) {
    const usedBy = (newVal.data as { usedBy: number }).usedBy;
    const shared = (newVal.data as { shared: boolean }).shared;
    const wasShared = (oldVal.data as { shared: boolean }).shared;
    if ((!shared && wasShared) || (usedBy && usedBy !== this.currentUser?.id)) {
      this.unlock();
    }
    if (!shared && wasShared && this.selected && this.isGuest) {
      this.snackbar = true;
      this.snackbarText = 'Element is no longer shared';
      this.snackbarTimeout = 2000;
    }
  }

  @Watch('doubleSelected')
  doubleClicked(newVal: boolean) {
    this.$parent.$parent.$emit('changeMoveable', !newVal);
    this.setDouble(newVal);
    if (newVal) {
      this.lock();
    } else {
      this.unlock();
    }
  }

  private wasSelected = false;

  @Watch('selected')
  async isSelected(newVal: boolean) {
    if (this.wasSelected != newVal) {
      this.wasSelected = newVal;
      if (!newVal) {
        this.setDouble(newVal);
        this.unlock();
      }
    }
  }
  timeout!: NodeJS.Timeout;

  resetTimer() {
    if (!this.isShared && !this.isLocked) return;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(this.unlock, 60 * 1000); // 60 sec
  }

  lock() {
    if (!(this.element.data as { usedBy: number }).usedBy) {
      this.updateElement({
        ...this.element,
        data: {
          ...this.element.data,
          usedBy: this.currentUser?.id,
        },
      });
    }
    this.resetTimer();
  }

  unlock() {
    if (this.isShared && !this.isLocked) {
      clearTimeout(this.timeout);
      if ((this.element.data as { usedBy: number }).usedBy === this.currentUser?.id) {
        this.updateElement({
          ...this.element,
          data: {
            ...this.element.data,
            usedBy: false,
          },
        });
      }
      this.$root.$emit('select', null);
      this.setDouble(false);
    }
  }
}
